import TimeTrackingPanel from "./TimeTrackingPanel";
import CostTrackingPanel from "./CostTrackingPanel";


export default function TrackingMainContainer({activeTrakingTab}) {
  return (
    <div className="w-full bg-white dark:bg-surface-dark mb-5">
      {/* CONTENT */}
      {activeTrakingTab === "time" ? <TimeTrackingPanel /> : <CostTrackingPanel />}
    </div>
  );
};


